<ng-container *ngIf="route">
    <div class="title">
        {{'SHARED.ROUTE.CHANGEMARKS.COMPONENT.TITLE' | translate}}
    </div>
    <div class="block-help">
        {{'SHARED.ROUTE.CHANGEMARKS.COMPONENT.HELP' | translate}}
    </div>

    <div class="col-x">
        <boolean-component class="col" [(ngModel)]="problem" (valueChanged)="updateValue()"
            matTooltip="{{'SHARED.ROUTE.CHANGEMARKS.PROBLEM' | translate}}" [showHelpPoint]=false
            placeholder="{{'SHARED.ROUTE.CHANGEMARKS.PROBLEM' | translate }}">
        </boolean-component>
    </div>
    <div class="col-x">
        <boolean-component class="col" [(ngModel)]="notready" (valueChanged)="updateValue()"
            placeholder="{{'SHARED.ROUTE.CHANGEMARKS.NOTREADY' | translate}}" [showHelpPoint]=false>
        </boolean-component>
    </div>
    <div class="col-x">
        <boolean-component class="col" [(ngModel)]="delayed" (valueChanged)="updateValue()"
            placeholder="{{'SHARED.ROUTE.CHANGEMARKS.DELAYED' | translate}}" [showHelpPoint]=false>
        </boolean-component>
    </div>
    <div class="col-x">
        <boolean-component class="col" [(ngModel)]="urgent" (valueChanged)="updateValue()"
            placeholder="{{'SHARED.ROUTE.CHANGEMARKS.URGENT' | translate}}" [showHelpPoint]=false>
        </boolean-component>
    </div>
</ng-container>